import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth/auth';

@Component({
  selector: 'app-header',
  imports: [RouterLink],
  templateUrl: './header.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './header.css',
})
export class Header {
  protected readonly auth = inject(AuthService);
  private readonly router = inject(Router);

  async logout(): Promise<void> {
    // AuthService.logout() never rejects (see its docblock), so this
    // navigation always runs. Without it, logging out from a protected
    // route (e.g. /competitions) leaves that component rendered with a now-
    // null user until the next navigation — caught via a live end-to-end
    // test, not a unit test. Goes straight to /login (not just home) so
    // there's no lingering doubt about whether logout actually happened.
    await this.auth.logout();
    await this.router.navigateByUrl('/login');
  }
}
